module.exports = __webpack_public_path__ + "media/images/upload-4ba602f1.svg";